import React from 'react';
import { withProps } from 'recompose';

import { InfoWindow } from 'components/core/GoogleMap';
import { Link } from 'components/core/Link';
import { Paragraph } from 'components/core/Typography';
import { FacilityRating } from 'components/facility/FacilityRating';
import { FacilityRatingLabel } from 'components/facility/FacilityRatingLabel';

export const enhance = withProps(({ facility }) => ({
	location: facility.location,
	content: (
		<div className="facility-info-window">
			<Link
				href={facility.url}
				className="facility-name"
				segmentLabel="facility pin modal title"
			>
				{facility.name}
			</Link>
			{!!facility.reviews.number &&
				<div className="facility-reviews-rating">
					<FacilityRating
						numberOfRatings={facility.reviews.number}
						average={facility.reviews.average}
						reviewsUrl={facility.url}
						renderLabel={FacilityRatingLabel}
					/>
				</div>
			}
			{!!facility.isOpen &&
				<Paragraph
					last
					className="open-now-text"
				>
					Open Now!
				</Paragraph>
			}
		</div>
	)
}));

export default enhance(InfoWindow);
